{
  "tab": "الوقت",
  "perHour": "للساعة",
  "settings": {
    "time": {
      "title": "الوقت",
      "body": "ما يمكن للأشخاص تسجيله من وقت على المشاريع، ومتى يُقفل.",
      "invalid": "راجع قواعد الوقت: إحدى القيم خارج النطاق المسموح.",
      "range": "أدخل رقمًا من {{min}} إلى {{max}}.",
      "quarter": "استخدم أرباع الساعة، مثل 7.5 أو 7.75.",
      "unit": {
        "days": "يوم",
        "hours": "ساعة"
      },
      "futureDays": {
        "label": "أيام مقدمًا",
        "hint": "يمكن تسجيل الوقت قبل موعده بهذا العدد من الأيام، للإجازات أو السفر المخطط لها. الصفر يسمح بتسجيل اليوم كحد أقصى."
      },
      "lockAfterDays": {
        "label": "القفل بعد",
        "hint": "الوقت الأقدم من هذا العدد من الأيام لا يمكن إضافته أو تعديله أو إرساله، ويبقى بإمكان المعتمِدين اعتماده أو إرجاعه."
      },
      "hoursPerDay": {
        "label": "ساعات يوم العمل",
        "hint": "ما يُتوقع أن يسجله العضو المخصَّص بالكامل في كل يوم عمل، والعضو المخصَّص بنسبة 50% يُتوقع منه النصف."
      },
      "weekStart": {
        "label": "بداية الأسبوع",
        "hint": "أول أيام الأسبوع في شاشة «وقتي» وفي الاعتمادات.",
        "SATURDAY": "السبت",
        "SUNDAY": "الأحد",
        "MONDAY": "الاثنين"
      },
      "requireTask": {
        "label": "كل سجل وقت يحدد مهمة",
        "hint": "يُسجَّل الوقت على إحدى مهام المشروع، لا على المشروع أو جزء الخطة وحده."
      }
    }
  },
  "time": {
    "off": "الوقت متوقف في هذا المشروع، ويمكن لمدير المشروع تشغيله من وظائف المشروع.",
    "title": "الوقت في هذا المشروع",
    "intro": "الساعات التي سجلها الأشخاص هنا، حسب الشخص والأسبوع.",
    "period": "من {{from}} إلى {{to}}، حسب الشخص والأسبوع.",
    "none": "لا شيء",
    "columns": {
      "week": "الأسبوع",
      "draft": "مسودة",
      "submitted": "بانتظار الاعتماد",
      "approved": "معتمد",
      "billable": "قابل للفوترة",
      "cost": "التكلفة",
      "bill": "القيمة القابلة للفوترة"
    },
    "state": {
      "DRAFT": "مسودة",
      "SUBMITTED": "بانتظار الاعتماد",
      "APPROVED": "معتمد"
    },
    "empty": "لم يُسجَّل وقت في هذه الفترة.",
    "emptyBody": "يسجل الأعضاء ساعاتهم في «وقتي»، فتظهر هنا مسودةً ثم بانتظار الاعتماد ثم معتمدة.",
    "tableLabel": "الوقت في {{code}} حسب الشخص والأسبوع",
    "weekOf": "أسبوع {{date}}",
    "total": "الإجمالي",
    "figures": {
      "label": "إجماليات الوقت للفترة",
      "approvedSub": "ساعات محسوبة في تكلفة المشروع",
      "submittedSub": "ساعات بانتظار الاعتماد",
      "billableSub": "للفوترة: معتمدة أو بانتظار الاعتماد",
      "labour": "تكلفة العمالة حتى تاريخه",
      "labourSub": "كل الوقت المعتمد في كل الفترات"
    },
    "footnote": "تُحسب الساعات في تكلفة المشروع عند اعتمادها، بتكلفة ساعة الشخص في يوم العمل. وتُفوتر الساعات القابلة للفوترة بسعر الفوترة الخاص بالعضو، وإلا فبسعر دور التسعير الخاص به.",
    "approve": "مراجعة {{hours}} بانتظار الاعتماد",
    "approvals": "اعتماد الوقت",
    "entries": {
      "toggle": "سجلات وقت {{person}}، {{week}}",
      "label": "وقت {{person}} في أسبوع {{week}}",
      "hint": "افتح أسبوع الشخص لترى سجلات وقته، ويمكن إرجاع الوقت المعتمد الذي لم يُفوتر ولم يُرحَّل بعد إلى صاحبه.",
      "empty": "لا توجد سجلات وقت على هذا المشروع في ذلك الأسبوع.",
      "columns": {
        "date": "التاريخ",
        "work": "المشروع › الخطة › المهمة",
        "status": "الحالة",
        "hours": "الساعات"
      },
      "selectAll": "تحديد كل سجلات وقت {{person}} القابلة للإرجاع",
      "select": "تحديد {{hours}} يوم {{day}}",
      "billed": "مُدرج في فاتورة عميل: ألغِ الفاتورة لإرجاعه.",
      "posted": "مُدرج في ترحيل تكلفة العمالة: ألغِ الترحيل لإرجاعه.",
      "waiting": "بانتظار الاعتماد: قرّر فيه من «اعتماد الوقت».",
      "own": "هذا وقتك: يُرجعه شخص آخر.",
      "notApproved": "غير معتمد: لا شيء لإرجاعه.",
      "returnBody": "يعود {{hours}} إلى صاحبه مع سببك، فيصحّح الوقت ويرسله مرة أخرى، ويخرج من تكلفة المشروع حتى يُعتمد من جديد."
    },
    "logTime": "تسجيل الوقت",
    "openMyTime": "فتح «وقتي»",
    "inactive": "غير نشط"
  },
  "roles": {
    "none": "بلا دور تسعير",
    "new": "دور تسعير جديد",
    "views": "عروض أدوار التسعير",
    "active": "النشطة",
    "archived": "المؤرشفة",
    "ratesHidden": "أسعار الفوترة أسعار بيع، وتظهر لمن لديه صلاحية عرض أموال المشاريع.",
    "emptyActive": "لا توجد أدوار تسعير بعد.",
    "emptyActiveBody": "أضف الأدوار التي يُفوتر بها وقت الأشخاص، مثل مهندس موقع أو مستشار، ولكل دور سعر فوترة للساعة.",
    "emptyArchived": "لا توجد أدوار تسعير مؤرشفة.",
    "listLabel": "أدوار التسعير",
    "archivedStamp": "مؤرشف",
    "members_zero": "لا أعضاء نشطون",
    "members_one": "عضو نشط واحد",
    "members_two": "عضوان نشطان",
    "members_few": "{{n}} أعضاء نشطين",
    "members_many": "{{n}} عضوًا نشطًا",
    "members_other": "{{n}} عضو نشط",
    "noBillRate": "بلا سعر فوترة: يحتاج الأعضاء إلى سعر خاص بهم",
    "edit": "تعديل {{name}}",
    "archive": "أرشفة {{name}}",
    "restore": "استعادة {{name}}",
    "archiveTitle": "أرشفة {{name}}؟",
    "archiveBody": "لن يمكن اختياره للأعضاء بعد الآن. ويحتفظ به الأعضاء الحاليون، ويُفوتر وقتهم بسعره.",
    "archiveConfirm": "أرشفة",
    "restoreTitle": "استعادة {{name}}؟",
    "restoreBody": "يمكن اختياره للأعضاء من جديد.",
    "restoreConfirm": "استعادة",
    "toast": {
      "saved": "حُفظ دور التسعير {{code}}",
      "archived": "أُرشف دور التسعير {{code}}",
      "restored": "استُعيد دور التسعير {{code}}"
    },
    "editTitle": "تعديل دور التسعير {{code}}",
    "newTitle": "دور تسعير جديد",
    "editorDescription": "دور يُفوتر به وقت الأشخاص في مشاريع الوقت والمواد. ويتقدم سعر الفوترة الخاص بالعضو، المحدد في فريق المشروع، على سعر الدور.",
    "save": "حفظ دور التسعير",
    "fields": {
      "code": "الرمز",
      "codeHint": "قصير وغير مكرر: حروف وأرقام ونقطة وشرطة وشرطة سفلية (SITE-ENG).",
      "name": "الاسم",
      "nameAr": "الاسم بالعربية",
      "billRate": "سعر الفوترة للساعة (<rial/>، قبل الضريبة)",
      "billRateHint": "ما تُفوتر به ساعة هذا الدور للعميل. اتركه فارغًا إذا كان لكل عضو سعره الخاص."
    }
  },
  "team": {
    "rateRole": "دور التسعير",
    "billRate": "سعر الفوترة",
    "allocation": "نسبة التخصيص",
    "fromRole": "من دور التسعير",
    "noRate": "بلا سعر فوترة: حدّد دور تسعير أو سعرًا خاصًا",
    "allocationRange": "أدخل نسبة مئوية صحيحة من 1 إلى 100، أو اترك الحقل فارغًا.",
    "timeLegend": "الوقت والأسعار",
    "rateRoleHint": "يُفوتر وقته القابل للفوترة بسعر هذا الدور ما لم يكن له سعر خاص.",
    "ownBillRate": "سعر الفوترة الخاص للساعة (<rial/>)",
    "ownBillRateHint": "اتركه فارغًا ليُفوتر بسعر دور التسعير الخاص به.",
    "ownBillRateHintRole": "اتركه فارغًا ليُفوتر بسعر الدور: {{rate}} للساعة.",
    "allocationHint": "الحصة المخطط لها من أسبوع عمله في هذا المشروع. اتركها فارغة إذا لم يكن متوقعًا منه تسجيل ساعات محددة هنا.",
    "noRateNeeded": "غير مطلوب: هذا المشروع لا يُفوتر الوقت"
  },
  "people": {
    "title": "تكلفة الساعة",
    "subtitle": "ما تتحمله الشركة عن كل ساعة عمل لكل شخص، وبها يُكلَّف وقته المعتمد في المشاريع.",
    "ruleTitle": "كيف يسري السعر الجديد",
    "rule": "يسري السعر الجديد على الوقت الذي يُعتمد من الآن، بالسعر الساري في يوم العمل. ويحتفظ الوقت المعتمد سابقًا بسعره؛ ولتكليفه بالسعر الجديد أرجِعه ثم اعتمده من جديد.",
    "views": "العروض",
    "all": "الجميع",
    "missing": "بلا سعر",
    "search": "ابحث عن شخص…",
    "clearSearch": "مسح البحث",
    "columns": {
      "person": "الشخص",
      "current": "تكلفة الساعة الحالية",
      "next": "السعر التالي",
      "projects": "المشاريع المفتوحة"
    },
    "since": "منذ {{date}}",
    "from": "ابتداءً من {{date}}",
    "noRate": "بلا سعر",
    "set": "تحديد سعر ابتداءً من…",
    "actionsFor": "إجراءات {{name}}",
    "noMatch": "لا أحد يطابق بحثك.",
    "noneMissing": "لكل شخص سعر.",
    "empty": "لا أحد لتكليف وقته بعد. يظهر الأشخاص هنا عندما يصبحون أعضاء في مشروع مفتوح.",
    "drawerTitle": "{{name}}: تكلفة الساعة",
    "drawerDescription": "أسعاره حسب التاريخ، وسعر جديد ابتداءً من تاريخ.",
    "setTitle": "تحديد سعر ابتداءً من…",
    "fields": {
      "costRate": "تكلفة الساعة (<rial/>)",
      "costRateHint": "ما تتحمله الشركة عن ساعة من عمله: الراتب والمزايا مقسومة على ساعات العمل.",
      "effectiveFrom": "ابتداءً من",
      "note": "ملاحظة"
    },
    "applies": "ابتداءً من {{date}}. يسري السعر الجديد على الوقت الذي يُعتمد من الآن، ويحتفظ الوقت المعتمد سابقًا بسعره.",
    "backdated": "ابتداءً من {{date}}. لا يسري السعر الجديد إلا على الوقت الذي يُعتمد من الآن، ويحتفظ الوقت المعتمد سابقًا بسعره. ولتكليفه بالسعر الجديد أرجِعه ثم اعتمده من جديد.",
    "replaces": "يحل محل السعر {{rate}} الساري ابتداءً من {{date}}. ويسري على الوقت الذي يُعتمد من الآن، ويحتفظ الوقت المعتمد سابقًا بسعره. ولتكليفه بالسعر الجديد أرجِعه ثم اعتمده من جديد.",
    "save": "حفظ السعر",
    "toast": {
      "saved": "{{name}}: {{rate}} للساعة ابتداءً من {{date}}"
    },
    "history": "الأسعار",
    "noHistory": "لا سعر بعد: يُكلَّف وقته بصفر عند اعتماده. يسري السعر الجديد على الوقت الذي يُعتمد من الآن؛ ولتكليف الوقت المعتمد سابقًا أرجِعه ثم اعتمده من جديد.",
    "inForce": "ساري",
    "upcoming": "قادم",
    "setBy": "حُدّد بواسطة {{name}}، {{date}}",
    "missingWarning_zero": "لا أحد بلا تكلفة للساعة",
    "missingWarning_one": "شخص واحد بلا تكلفة للساعة: وقته المعتمد يكلف 0",
    "missingWarning_two": "شخصان بلا تكلفة للساعة: وقتهما المعتمد يكلف 0",
    "missingWarning_few": "{{n}} أشخاص بلا تكلفة للساعة: وقتهم المعتمد يكلف 0",
    "missingWarning_many": "{{n}} شخصًا بلا تكلفة للساعة: وقتهم المعتمد يكلف 0",
    "missingWarning_other": "{{n}} شخص بلا تكلفة للساعة: وقتهم المعتمد يكلف 0",
    "showMissing": "عرضهم"
  },
  "labour": {
    "action": "ترحيل تكلفة العمالة…",
    "title": "ترحيل تكلفة العمالة",
    "description": "قيد تكلفة من نوع ترحيل العمالة ينقل الوقت المعتمد إلى الدفاتر.",
    "explain": "يجعل تكلفة العمالة في كل مشروع مدينة ويقيد الإجمالي دائنًا في الحساب الذي تختاره، ويتخطى الوقت المرحَّل سابقًا.",
    "defaultDescription": "تكلفة عمالة الوقت المعتمد حتى {{date}}",
    "books": "يُرحَّل كل سطر إلى حساب فئة العمالة الخاصة به. وقد احتسبت المشاريع هذه التكلفة عند اعتماد الوقت، فلا تتغير أرقامها.",
    "fields": {
      "through": "الوقت المُنجَز حتى",
      "throughHint": "الوقت المعتمد المُنجَز في هذا التاريخ أو قبله ولم يُرحَّل بعد.",
      "project": "المشروع",
      "projectHint": "اتركه فارغًا لكل المشاريع التي يمكنك رؤيتها، وتُتخطى المشاريع المغلقة وتلك التي أُوقفت فيها قيود التكاليف أو الوقت.",
      "allProjects": "كل المشاريع",
      "clearProject": "كل المشاريع",
      "entryDate": "تاريخ القيد",
      "entryDateHint": "تاريخ قيد اليومية.",
      "creditAccount": "الحساب الدائن",
      "creditAccountHint": "الحساب الذي يُقيد فيه الإجمالي دائنًا: حساب التزام مثل الرواتب المستحقة أو حساب وسيط للعمالة، أو حساب مصروف.",
      "creditAccountPlaceholder": "اختر الحساب الدائن",
      "description": "الوصف"
    },
    "errors": {
      "account": "اختر الحساب الدائن."
    },
    "preview": "معاينة",
    "refresh": "معاينة من جديد",
    "post": "ترحيل تكلفة العمالة",
    "stale": "تغيرت البيانات بعد المعاينة. عاين من جديد قبل الترحيل.",
    "nothing": "لا وقت معتمدًا بانتظار الترحيل حتى هذا التاريخ.",
    "previewTitle_zero": "لا سجلات وقت معتمدة للترحيل",
    "previewTitle_one": "سجل وقت معتمد واحد للترحيل",
    "previewTitle_two": "سجلّا وقت معتمدان للترحيل",
    "previewTitle_few": "{{count}} سجلات وقت معتمدة للترحيل",
    "previewTitle_many": "{{count}} سجل وقت معتمد للترحيل",
    "previewTitle_other": "{{count}} سجل وقت معتمد للترحيل",
    "missingTitle_zero": "لا سجلات وقت بلا تكلفة ساعة",
    "missingTitle_one": "سجل وقت واحد بلا تكلفة ساعة",
    "missingTitle_two": "سجلّا وقت بلا تكلفة ساعة",
    "missingTitle_few": "{{count}} سجلات وقت بلا تكلفة ساعة",
    "missingTitle_many": "{{count}} سجل وقت بلا تكلفة ساعة",
    "missingTitle_other": "{{count}} سجل وقت بلا تكلفة ساعة",
    "missingBody": "لم يكن لأصحابها سعر في يوم العمل، فتُرحَّل بصفر. ولتكليفها: حدّد سعرًا يسري من ذلك اليوم، ثم أرجِع الوقت واعتمده من جديد.",
    "setRates": "تحديد تكلفة الساعة",
    "previewCaption": "الأسطر المدينة والدائنة في الترحيل",
    "creditLine": "دائن",
    "balanced": "المدين يساوي الدائن",
    "usualChoice": "{{type}} · الخيار المعتاد",
    "columns": {
      "project": "المشروع",
      "node": "جزء الخطة",
      "category": "الفئة",
      "hours": "الساعات",
      "amount": "المبلغ",
      "debit": "مدين",
      "credit": "دائن"
    },
    "entries_zero": "لا سجلات وقت",
    "entries_one": "سجل وقت واحد",
    "entries_two": "سجلّا وقت",
    "entries_few": "{{count}} سجلات وقت",
    "entries_many": "{{count}} سجل وقت",
    "entries_other": "{{count}} سجل وقت",
    "total": "الإجمالي",
    "toast": {
      "posted": "رُحّلت تكلفة العمالة في القيد {{number}}"
    }
  }
}
